import { FormattedMessage, FormattedTime } from 'react-intl'
import * as Metadata from 'components/metadata'
import { DayPicker } from 'components/controls'
import { useContext } from './context'
import { AmericaVancouver } from '@avcan/constants/timeZoneNames'
import { TIME } from '@avcan/constants/intl/formats'

// Utils
export default function WeatherForecastMetadata() {
    const { forecast, onDateChange, date, prefetch } = useContext()

    return (
        <Metadata.Container>
            <Metadata.Entry
                term={
                    <FormattedMessage
                        description="Layout weather/forecast/Forecast"
                        defaultMessage="Date"
                    />
                }
                horizontal>
                <DayPicker
                    date={date}
                    onChange={onDateChange}
                    onDayMouseEnter={prefetch}
                    onDayFocus={prefetch}
                    onDayTouchStart={prefetch}
                />
            </Metadata.Entry>
            {forecast && (
                <Metadata.Entry
                    term={
                        <FormattedMessage
                            description="Layout weather/forecast/Forecast"
                            defaultMessage="Issued at"
                        />
                    }
                    horizontal>
                    {forecast.issued || '04:00'} PDT/PST
                </Metadata.Entry>
            )}
            {forecast && (
                <Metadata.Entry
                    term={
                        <FormattedMessage
                            description="Layout weather/forecast/Forecast"
                            defaultMessage="Created by"
                        />
                    }
                    horizontal>
                    {forecast.handle}
                </Metadata.Entry>
            )}
        </Metadata.Container>
    )
}
